// @ts-strict-ignore
import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { cacheKey } from "./constants";
import type { EngagementWebhookTemplatesParams, EngagementWebhookTemplatesResult } from "./types";

export const getWebhookMessageTemplates = reactQueryTableFetcherAdapter(
  cacheKey,
  (
    signal: AbortSignal,
    { appGroupId, query = {}, groupby, limit = 20, start = 0, sortdir, sortby }: EngagementWebhookTemplatesParams
  ): Promise<EngagementWebhookTemplatesResult> => {
    return fetch(
      "/engagement/webhook_templates",
      "GET",
      {
        groupby,
        limit,
        sortby,
        sortdir,
        start,
        app_group_id: appGroupId,
        query: serializeQueryObjects(query),
        show_all_template_types: true,
      },
      { signal }
    );
  }
);
